import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo192.png";

const socialLinks = [
  { label: "Facebook", href: "#", path: "M22 12a10 10 0 1 0-11.6 9.9v-7H7.9V12h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.3c-1.2 0-1.6.8-1.6 1.6V12h2.8l-.4 2.9h-2.4v7A10 10 0 0 0 22 12Z" },
  { label: "Twitter", href: "#", path: "M22 5.9c-.7.3-1.5.6-2.3.7a4 4 0 0 0 1.8-2.2 8 8 0 0 1-2.5 1 4 4 0 0 0-6.9 3.6A11.4 11.4 0 0 1 3.6 4.7a4 4 0 0 0 1.2 5.3 4 4 0 0 1-1.8-.5v.1a4 4 0 0 0 3.2 3.9 4 4 0 0 1-1.8.1 4 4 0 0 0 3.7 2.8A8 8 0 0 1 2 18.4a11.3 11.3 0 0 0 6.1 1.8c7.3 0 11.3-6.1 11.3-11.3v-.5c.8-.6 1.4-1.3 1.9-2.1Z" },
  { label: "Instagram", href: "#", path: "M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 2 .2 2.6.5.7.3 1.1.6 1.6 1.1.5.5.8.9 1.1 1.6.3.6.4 1.4.5 2.6.1 1.2.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.2 2-.5 2.6a4.4 4.4 0 0 1-2.6 2.6c-.6.3-1.4.4-2.6.5-1.2.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-2-.2-2.6-.5a4.4 4.4 0 0 1-2.6-2.6c-.3-.6-.4-1.4-.5-2.6C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8c.1-1.2.2-2 .5-2.6A4.4 4.4 0 0 1 5.4 2c.6-.3 1.4-.4 2.6-.5C9.2 1.4 9.6 1.4 12.8 1.4Zm0 1.8c-3.1 0-3.5 0-4.7.1-1 .1-1.6.2-2 .3a2.5 2.5 0 0 0-1 .6 2.5 2.5 0 0 0-.6 1c-.1.4-.2 1-.3 2-.1 1.2-.1 1.6-.1 4.7s0 3.5.1 4.7c.1 1 .2 1.6.3 2 .1.4.3.7.6 1 .3.3.6.5 1 .6.4.1 1 .2 2 .3 1.2.1 1.6.1 4.7.1s3.5 0 4.7-.1c1-.1 1.6-.2 2-.3.4-.1.7-.3 1-.6.3-.3.5-.6.6-1 .1-.4.2-1 .3-2 .1-1.2.1-1.6.1-4.7s0-3.5-.1-4.7c-.1-1-.2-1.6-.3-2a2.5 2.5 0 0 0-.6-1 2.5 2.5 0 0 0-1-.6c-.4-.1-1-.2-2-.3-1.2-.1-1.6-.1-4.7-.1Zm0 3.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 1.8a2.7 2.7 0 1 0 0 5.4 2.7 2.7 0 0 0 0-5.4Zm5.7-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" },
];

const exploreLinks = [
  { label: "Find games", to: "/" },
  { label: "Browse games", to: "/games" },
  { label: "Favorites", to: "/favorites" },
  { label: "About us", to: "/about" },
];

const legalLinks = [
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy" },
];

const FooterLink = ({ to, children }) => (
  <li>
    <Link
      to={to}
      className="group inline-flex items-center gap-1.5 text-sm text-white/55 transition-colors hover:text-brand-gold"
    >
      <span className="h-px w-0 bg-brand-gold transition-all duration-200 group-hover:w-3" />
      {children}
    </Link>
  </li>
);

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative w-full mt-auto shrink-0 overflow-hidden border-t border-white/10 bg-surface/80 backdrop-blur-xl text-white font-body">
      {/* ambient accents */}
      <span className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-gold/70 to-transparent" />
      <span className="pointer-events-none absolute -top-32 left-1/2 -translate-x-1/2 h-56 w-[70%] rounded-full bg-brand-purple/20 blur-3xl" />
      <div className="pointer-events-none absolute inset-0 gg-grid-backdrop opacity-[0.12]" />

      {/* CTA band */}
      <div className="relative max-w-[1200px] mx-auto px-6 pt-10">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-brand-gradient-135 px-6 sm:px-10 py-7 flex flex-col sm:flex-row items-center justify-between gap-5 text-center sm:text-left">
          <div className="absolute inset-0 gg-grid-backdrop opacity-25" />
          <div className="relative">
            <h3 className="font-heading font-extrabold text-xl sm:text-2xl text-white">
              Find your next favourite game
            </h3>
            <p className="text-white/80 text-sm mt-1">
              Search smarter and get recommendations tuned to your taste.
            </p>
          </div>
          <Link
            to="/games"
            className="relative shrink-0 rounded-full bg-white text-[#0b0916] px-6 py-3 font-heading font-bold shadow-card transition-transform duration-200 hover:-translate-y-0.5"
          >
            Start browsing →
          </Link>
        </div>
      </div>

      {/* Main */}
      <div className="relative max-w-[1200px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1.6fr,1fr,1fr,1.2fr] gap-8 lg:gap-10 px-6 py-10">
        {/* Brand */}
        <div>
          <Link to="/" className="group inline-flex items-center gap-3">
            <span className="relative flex items-center justify-center">
              <span className="absolute inset-0 rounded-full bg-brand-purple/40 blur-md opacity-70 group-hover:opacity-100 transition-opacity" />
              <img
                src={logo}
                alt="Game Goblin logo"
                className="relative h-[100px] object-contain drop-shadow-[0_2px_10px_rgba(151,1,251,0.5)]"
              />
            </span>
            {/* <span className="leading-none">
              <span className="block font-heading font-extrabold text-xl">
                Game<span className="gg-gradient-text">Goblin</span>
              </span>
              <span className="block text-[0.62rem] font-semibold uppercase tracking-[0.25em] text-brand-gold/80 mt-1">
                Game Finder
              </span>
            </span> */}
          </Link>
          <p className="text-sm text-white/50 max-w-xs mt-0 leading-relaxed">
            Your companion in the hunt for new games. Search, discover, and organize the
            titles worth your time.
          </p>
          <div className="flex gap-2 mt-5">
            {socialLinks.map((s) => (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                className="flex items-center justify-center h-9 w-9 rounded-full border border-white/10 bg-white/[0.04] text-white/70 transition-all duration-200 hover:text-brand-gold hover:border-brand-gold/50 hover:-translate-y-0.5"
              >
                <svg viewBox="0 0 24 24" width="17" height="17" fill="currentColor">
                  <path d={s.path} />
                </svg>
              </a>
            ))}
          </div>
        </div>

        {/* Explore */}
        <div>
          <h6 className="font-heading font-bold text-sm uppercase tracking-wider text-white/80 mb-4">
            Explore
          </h6>
          <ul className="space-y-2.5">
            {exploreLinks.map((l) => (
              <FooterLink key={l.to} to={l.to}>
                {l.label}
              </FooterLink>
            ))}
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h6 className="font-heading font-bold text-sm uppercase tracking-wider text-white/80 mb-4">
            Legal
          </h6>
          <ul className="space-y-2.5">
            {legalLinks.map((l) => (
              <FooterLink key={l.to} to={l.to}>
                {l.label}
              </FooterLink>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h6 className="font-heading font-bold text-sm uppercase tracking-wider text-white/80 mb-4">
            Get in touch
          </h6>
          <a
            href="mailto:info@gamegoblin.eu"
            className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-brand-gold transition-colors"
          >
            <span className="text-brand-gold">✉️</span> info@gamegoblin.eu
          </a>
          <a
            href="https://rawg.io/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 text-xs text-white/55 hover:text-brand-gold hover:border-brand-gold/40 transition-colors"
          >
            🎮 Powered by RAWG
          </a>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="relative border-t border-white/10">
        <div className="max-w-[1200px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 px-6 py-5">
          <span className="text-xs text-white/45 order-2 sm:order-1">
            © {year} <b className="text-white/70">GameGoblin</b>. All rights reserved.
          </span>
          <span className="text-xs text-white/45 order-1 sm:order-2">
            Made with <span className="text-red-400">❤</span> by{" "}
            <a
              href="https://codeperfecto.com"
              title="Websites & Mobile Application Development Company!"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-gold hover:text-brand-gold/70 transition-colors font-semibold"
            >
              CodePerfecto
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
